import { inject } from '@angular/core';
import { type HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { ENTRA_AUTH_CONFIG } from './entra-auth.config';
import { EntraAuthService } from './entra-auth.service';

export const entraAuthInterceptor: HttpInterceptorFn = (request, next) => {
  const config = inject(ENTRA_AUTH_CONFIG);

  if (!config.enabled || !request.url.startsWith(config.apiBaseUrl)) {
    return next(request);
  }

  const authService = inject(EntraAuthService);

  // If the user is not authenticated, let the request through without a token.
  // The API will return 401 if the endpoint actually requires auth.
  if (!authService.isAuthenticated()) {
    return next(request);
  }

  return from(authService.acquireApiAccessToken()).pipe(
    switchMap((accessToken) => {
      if (!accessToken) {
        return EMPTY;
      }

      return next(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`
          }
        })
      );
    }),
    catchError((error) => {
      throw error;
    })
  );
};

